import React from "react";
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  tone?: "light" | "dark";
};
export function SectionHeading({
  eyebrow,
  title,
  tone = "light"
}: SectionHeadingProps) {
  const dark = tone === "dark";
  return <div className="text-center" data-id="element-70" data-mp="3f2wxhmr351x8">
      {eyebrow && <p className={`font-display text-sm uppercase tracking-[0.2em] ${dark ? "text-brand-mist/80" : "text-brand-sage"}`} data-id="element-71" data-mp="3jznfifmga7la">
          {eyebrow}
        </p>}
      <h2 className={`mt-3 font-serif text-[32px] font-bold leading-[1.1] [text-wrap:balance] md:text-5xl ${dark ? "text-cream" : "text-ink"}`} data-id="element-72" data-mp="bmpvrls8der3">
        {title}
      </h2>
    </div>;
}